import React from 'react';
import PropTypes from 'prop-types';

const ArrowUpIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 8 4" transform="rotate(180)">
        <path d="M4 4L0 0h8z" fill={fill} />
    </svg>
);

ArrowUpIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

ArrowUpIcon.defaultProps = {
    width: '8',
    height: '4',
    fill: '#4b254e'
};

export default ArrowUpIcon;
